// src/services/appAccesosService.js
// Accesos por usuario a modulos de la app Android (por ahora, las Cajas).
import axios from "../config/axiosConfig";

// { modulos: [{clave, nombre, ruta}], usuarios: [{id, username, nombre, role, sub_rol, sucursal, modulos: [clave]}] }
export const listAccesosApp = () => axios.get("/api/app-accesos");

export const setAccesosAppUsuario = (usuarioId, modulos) =>
  axios.put(`/api/app-accesos/${usuarioId}`, { modulos });
